import { render, staticRenderFns } from "./SaveIcon.vue?vue&type=template&id=266cbd16&"
import script from "./SaveIcon.vue?vue&type=script&lang=js&"
export * from "./SaveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports